import React from 'react';
import { useNavigation } from '@hooks/navigation';
import Main from './Main';
import { BackButtonProps } from './interfaces';

const BackButton: React.FC<BackButtonProps> = ({ callback, style }) => {
  const { goBack } = useNavigation();

  return <Main callback={callback || goBack} style={style} />;
};

export default BackButton;
